export default __webpack_public_path__ + "static/media/BonusBoxClose.257f9f87.png";